import React, { useEffect } from 'react';
import { useForm } from 'react-final-form';

import * as hooks from './hooks';

export const RegistrationUserValues: React.FC = () => {
    const { batch, change } = useForm();
    const registrationUserValues = hooks.useRegistrationUserValues();

    useEffect(() => {
        batch(() => {
            Object.entries(registrationUserValues).forEach(([key, value]) => {
                change(key, value);
            });
        });
    }, [registrationUserValues, batch, change]);

    return null;
};
